<template>
  <article>
    <custom-callout class="mt-3" :has-toggle="false" border-color="gray">
      <div class="row pt-2">
        <div class="col-6 col-md-2">
          <div class="info-text-title">
            Nombre del Asistente:
          </div>
          <p class="info-text font-weight-bold">
            {{ value.name }}
          </p>
        </div>
        <div class="col-6 col-md-2">
          <div class="info-text-title">
            Número Puesto/Contrato:
          </div>
          <p class="info-text font-weight-bold">
            {{ value.contractNumber }}
          </p>
        </div>
        <div class="col-6 col-md-2">
          <div class="info-text-title">
            Tipo de Recurso:
          </div>
          <p class="info-text font-weight-bold">
            {{ resourceType }}
          </p>
        </div>
        <div class="col-6 col-md-2">
          <div class="info-text-title">
            Jornada Diaria:
          </div>
          <p class="info-text font-weight-bold">
            {{ dailyShift }}
          </p>
        </div>
        <div class="col-6 col-md-2">
          <div class="info-text-title">
            Cantidad de Estudiantes:
          </div>
          <p class="info-text font-weight-bold">
            {{ value.numberOfStudents }}
          </p>
        </div>
        <div class="col-12 col-md-2 d-md-flex justify-content-end">
          <div class="align-self-center d-flex justify-content-end align-items-center">
            <span v-if="isAddedManual" class="manual-chip mr-2">
              Manual
            </span>
            <ActionButton
              v-if="!isAddedManual"
              text="Remover"
              variant="outline-danger"
              i="far fa-minus-circle"
              :responsive="true"
              @click="$emit('remove')"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <div v-if="value.showOriginalRoomWarning" class="panel__container">
      <i class="fas fa-bell-exclamation icon" />
      <span class="panel-text">
        No pertenece al Salón Originalmente.
      </span>
    </div>
  </article>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';

export default {
  name: 'AssistantResultRow',
  components: {
    ActionButton,
    CustomCallout,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    resourceType() {
      if (!this.value.resourceType) return '';
      if (!this.value.rpServiceType) return this.value.resourceType.name;

      return `${this.value.resourceType.name} - ${this.value.rpServiceType.name}`;
    },
    dailyShift() {
      if (!this.value.dailyShift) return '';
      return `${this.value.dailyShift} horas`;
    },
    isAddedManual() {
      return this.value.addedManual || this.value.AddedManual;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.info-text-title {
  color: map.get($colors, 'gray-6');
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, 'black');
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}

.panel__container .panel-text {
  color: #af6708;
  margin-left: 12px;
}

.panel__container .icon {
  font-size: 22px;
  color: #af6708;
}

.panel__container {
  padding: 16px 25px;
  background: #fff5e8;
  border: 1px solid #fdac41;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.manual-chip {
  align-items: center;
  background: #D7FFF0;
  border: 1px solid #2db782;
  border-radius: 16px;
  color: #2DB782;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  padding: 5px 12px;
}
</style>
